import { motion } from "framer-motion";
import {
  Factory,
  HardHat,
  Stethoscope,
  UtensilsCrossed,
  GraduationCap,
  Landmark,
  Zap,
  Mountain,
  Car,
} from "lucide-react";
import { INDUSTRIES } from "@/lib/eraContent";
import { useLang } from "@/lib/LanguageContext";

const ICON_MAP = {
  Factory,
  HardHat,
  Stethoscope,
  UtensilsCrossed,
  GraduationCap,
  Landmark,
  Zap,
  Mountain,
  Car,
};

export const Industries = () => {
  const { t } = useLang();

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-6">
            <span className="text-xs uppercase tracking-[0.28em] font-semibold text-navy-900">
              {t.industries.eyebrow}
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-navy-900">
              {t.industries.title}{" "}
              <span className="text-gold-600">{t.industries.titleAccent}</span>
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-navy-700/70 leading-relaxed max-w-xl">
              {t.industries.subtitle}
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICON_MAP[ind.icon] || Factory;
            const label = t.industries.labels[ind.key];
            return (
              <motion.div
                key={ind.key}
                data-testid={`industry-card-${ind.key}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.05 }}
                className="group relative rounded-3xl bg-navy-50/50 hover:bg-white border border-navy-100 hover:border-navy-200 p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(13,27,62,0.15)]"
              >
                <div className="flex items-center justify-between">
                  <div className="h-12 w-12 rounded-2xl bg-white border border-navy-100 flex items-center justify-center transition-all duration-300 group-hover:bg-navy-900 group-hover:border-navy-900 group-hover:scale-110">
                    <Icon className="w-5 h-5 text-navy-900 transition-colors group-hover:text-gold" />
                  </div>
                  <span className="text-xs font-mono text-navy-500/60">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-8">
                  <h3 className="font-display text-lg md:text-xl font-medium text-navy-900 tracking-tight">
                    {label}
                  </h3>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
